import Wrapper from "_src/wrapper";
import { objectType } from "_src/constants";

export default class GroupableWrapper extends Wrapper {
  constructor(params={}) {
    super(params);
    this.type = objectType.GROUP;
  }

  getGroup() {
    return this._selfPropertyGetter("groupID");
  }

  setGroup(groupID) {
    this._selfPropertySetter("groupID", groupID);
  }
}
